import UserAndUserGroupManageComponent, { UserAndUserGroupManagePropsType } from './UserAndUserGroupManageComponent';

const CustomComponent = (props: any) => {
    const { userId, closeModal } = props;
    const apiId = 'userBrand';
    //表头
    const columnsHead = [
        {
            title: '用户',
            dataIndex: 'user',
            render: (text: any) => (typeof text !== "undefined" && text !== null ?
                text.userName :
                '')
        },
        {
            title: '品牌',
            dataIndex: 'brand',
            render: (text: any) => (typeof text !== "undefined" && text !== null ?
                text.brandName :
                '')
        }
    ];
    let extendProps: UserAndUserGroupManagePropsType = {
        mode: 'user',
        titleName: '用户品牌管理',
        apiId,
        userOrUserGroupId: userId,
        columnsHead,
        closeModal,
        options: {
            showDefault: true
        }
    }

    return (
        <>
            <UserAndUserGroupManageComponent extendData={extendProps} ></UserAndUserGroupManageComponent>
        </>
    )
}

export default CustomComponent;